<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="page-title">
        <h2>{{ $t("genoPerformance.performanceOfGenoType") }}</h2>
        <v-spacer></v-spacer>

        <v-btn
          color="primary"
          dark
          :to="{ name: 'GenoRegistration' }"
        >
          {{ $t("genoPerformance.addAGenoType") }}
        </v-btn>
      </div>
      <!---------------------- Tablet screen ------------------------------>
      <!-- start -->
      <v-card
        class="px-4"
        :class="loading ? '' : 'py-1'"
        v-if="checkBreakPoints"
        elevation="0"
        :loading="loading"
      >
        <div class="d-flex mt-5">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            outlined
            height="5px"
            :placeholder='$t("search")'
            dense
            v-model="search"
            @click:append="searchGenos"
            @input="resetSearchOnEmpty"
            class="shrink"
          ></v-text-field>
          <v-btn
            :disabled="search.length < 1"
            color="primary"
            height="40"
            width="40"
            max-width="40"
            outlined
            class="ml-8"
            @click="searchGenos"
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <div class="py-1 title">
            {{ from }} - {{ to }} of {{ totalgenos }}
          </div>
          <v-btn
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            :disabled="tabletTableOptions.page <= 1"
            @click="tabletPageChange(false)"
          >
            <v-icon dark> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            :disabled="tabletTableOptions.page >= totalPages"
            @click="tabletPageChange(true)"
          >
            <v-icon dark> mdi-chevron-right </v-icon>
          </v-btn>
        </div>
        <v-card
          class="inner-card my-4"
          v-for="(item, index) in items"
          :key="item.farmNumber"
          :elevation="0"
          :style="
            index % 2 !== 0 && { backgroundColor: 'rgba(243, 243, 243, 0.5)' }
          "
          @click="
            $router.push({
              name: 'GenoTypeView',
              params: { id: item.GTPerformanceNumber },
            })
          "
        >
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">{{ $t("genoPerformance.breedName") }}</v-col>
            <v-col md="6" style="color: #787878">{{ item.breedName }}</v-col>
          </v-row>
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">{{ $t("genoPerformance.chromosome") }}</v-col>
            <v-col md="6" style="color: #787878">{{ item.chromosome }}</v-col>
          </v-row>
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">{{ $t("genoPerformance.sequenceChange") }}</v-col>
            <v-col md="6" style="color: #787878">{{
              item.sequenceChange
            }}</v-col>
          </v-row>
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">{{ $t("genoPerformance.inheritance") }}</v-col>
            <v-col md="6" style="color: #787878">{{ item.inheritance }}</v-col>
          </v-row>
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">{{ $t("genoPerformance.diseaseName") }}</v-col>
            <v-col md="6" style="color: #787878">{{ item.diseaseName }}</v-col>
          </v-row>
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">{{ $t("genoPerformance.referenceSequence") }}</v-col>
            <v-col md="6" style="color: #787878">{{
              item.referenceSequence
            }}</v-col>
          </v-row>
          <v-row no-gutters class="py-2 px-8">
            <v-col md="6">{{ $t("genoPerformance.pubmedReference") }}</v-col>
            <v-col md="6" style="color: #787878">{{
              item.pubmedReference
            }}</v-col>
          </v-row>
        </v-card>
      </v-card>
      <!------------------- end ------------------------------>
      <v-card v-else elevation="0" class="px-5">
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            v-model="selected"
             item-key="GTPerformanceNumber"
            :items-per-page="10"
            :loading="loading"
            :loading-text='$t("genoPerformance.loadingGene")'
            :hide-default-footer="true"
            :footer-props="{
              'items-per-page-options': [5, 10, 25],
              'show-first-last-page': true,
              'show-current-page': true,
              'items-per-page-text': 'Geno per page',
            }"
            :options.sync="tableOptions"
            :server-items="totalgenos"
            :header-props="{
              'sort-icon': 'mdi-unfold-more-horizontal'
            }"
          >
            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  height="5px"
                  placeholder="Search"
                  dense
                  v-model="search"
                  @click:append="searchGenos"
                  @input="resetSearchOnEmpty"
                  class="shrink"
                ></v-text-field>
                <v-btn
                  :disabled="search.length < 1"
                  color="primary"
                  height="40"
                  width="40"
                  max-width="40"
                  outlined
                  class="ml-8"
                  @click="searchGenos"
                >
                  <v-icon>mdi-filter-outline</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ from }} - {{ to }} of {{ totalgenos }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="8"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-if="items.length > 0" v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.GTPerformanceNumber"
                  @mouseover="selectItem(item)"
                  @mouseleave="unSelectItem()"
                  style="position: relative; width: 0; height: 0"
                  @click="
                    $router.push({
                      name: 'GenoTypeView',
                      params: { id: item.GTPerformanceNumber },
                    })
                  "
                >
                  <!-- <td>
                    <v-checkbox
                      multiple
                      v-model="selected"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                      v-on:click.stop=""
                    />
                  </td> -->
                  <td>{{ item.breedName }}</td>
                  <td>{{ item.chromosome }}</td>
                  <td>{{ item.sequenceChange }}</td>
                  <td>{{ item.inheritance }}</td>
                  <td>{{ item.diseaseName }}</td>
                  <td>{{ item.referenceSequence }}</td>
                  <td>{{ item.pubmedReference }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import Breadcrumb from "@/components/core/Breadcrumb";
import GenoService from "@/_services/GenoService";

export default {
  components: {
    breadcrumb: Breadcrumb,
  },
  watch: {
    tableOptions: {
      handler() {
        this.getGenos();
      },
      deep: true,
    },
  },
  created() {
    if (this.checkBreakPoints) this.getTabletGenos();
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  async mounted() {
    document.title = "GenoType";
    // await this.getGenos()
  },
  methods: {
    // previous(){
    //     this.pageNo--
    //     this.numbers.splice(this.numbers.length-1)
    //     this.getfarm()
    // },
    // async next(){
    //     this.pageNo++
    //     await this.getfarm()
    //     this.numbers.push(this.numbers.length+1)
    // },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },

    searchGenos() {
      if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletGenos();
      } else {
        this.tableOptions.page = 1;
        this.getGenos();
      }
    },
    resetSearchOnEmpty() {
      if (this.search === "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.getTabletGenos();
      } else {
        this.tableOptions.page = 1;
        this.getGenos();
      }
    },
    getGenos() {
      this.loading = true;
      GenoService.getGenos(this.tableOptions, this.search)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.items = res.data.genotypePerformance.rows;
            this.currentrows = res.data.genotypePerformance.num_rows;
            this.totalgenos = res.data.genotypePerformance.total_rows;
            this.pageCount = Math.ceil(
              this.totalgenos / this.tableOptions.itemsPerPage
            );
            this.totalPages = Math.ceil(
              this.totalgenos / this.tableOptions.itemsPerPage
            );
            this.from =
              (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
            this.to =
              this.tableOptions.page * this.tableOptions.itemsPerPage -
              (this.tableOptions.itemsPerPage -
                res.data.genotypePerformance.num_rows);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    getTabletGenos() {
      this.loading = true;
      GenoService.getGenos(this.tabletTableOptions, this.search)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.items = res.data.genotypePerformance.rows;
            this.currentrows = res.data.genotypePerformance.num_rows;
            this.totalgenos = res.data.genotypePerformance.total_rows;
            this.pageCount = Math.ceil(
              this.totalgenos / this.tabletTableOptions.itemsPerPage
            );
            this.totalPages = Math.ceil(
              this.totalgenos / this.tabletTableOptions.itemsPerPage
            );
            this.from =
              (this.tabletTableOptions.page - 1) *
                this.tabletTableOptions.itemsPerPage +
              1;
            this.to =
              this.tabletTableOptions.page *
                this.tabletTableOptions.itemsPerPage -
              (this.tabletTableOptions.itemsPerPage -
                res.data.genotypePerformance.num_rows);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;
      this.getGenos();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      this.getTabletGenos();
    },
  },
  data() {
    return {
      from: 0,
      to: 0,
      totalPages: 1,
      showingRows: 0,
      currentrows: 0,
      search: "",
      selected: [],
      items: [],
      totalgenos: 1,
      selectedItem: false,
      loading: false,
      pageCount: 0,
      tableOptions: {},
      tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      loadingText: this.$t('loadingPleaseWait'),
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('dashboardS.performanceOfGeno'),
          disabled: true,
        },
      ],
      headers: [
        {
          text: this.$t('dashboardS.breed'),
          align: "start",
          value: "breedName",
        },
        { text: this.$t('dashboardS.chromosome'), value: "chromosome" },
        { text: this.$t('dashboardS.seqChange'), value: "sequenceChange" },
        { text: this.$t('dashboardS.inheritance'), align: "center", value: "inheritance" },
        { text: this.$t('dashboardS.diseaseName'), align: "center", value: "diseaseName" },
        {
          text: this.$t('dashboardS.refSequence'),
          align: "center",
          value: "referenceSequence",
        },
        { text: this.$t('dashboardS.pubmedRef'), value: "pubmedReference", align: "center" },
      ],
      // users: [],
    };
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}
.page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 0px 15px;
}

::v-deep .v-data-table-header th {
  white-space: nowrap;
}
::v-deep .v-data-table-header__icon {
  display: inline-block;
  opacity: 100 !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>